module.exports = __webpack_public_path__ + "img/报名条件@2x.0b19b88a.png";